package com.picme

import com.lightningkite.kiteui.navigation.ScreenNavigator
import com.lightningkite.kiteui.root

fun main() {
    root(appMaterialTheme) { app(ScreenNavigator { AutoRoutes }, ScreenNavigator { AutoRoutes }) }
}
